module.exports = __webpack_public_path__ + "static/media/moveTool.85a4c746.gif";